import React from 'react';
import { AlertTriangle, Zap } from 'lucide-react';

const AlertCard = ({ title, desc, type, onAction }) => (
  <div className={`p-6 rounded-2xl border flex gap-6 items-start shadow-sm bg-white ${type === 'error' ? 'border-l-4 border-l-red-500' : 'border-l-4 border-l-green-500'}`}>
     <div className={`p-3 rounded-xl ${type === 'error' ? 'bg-red-50 text-red-500' : 'bg-green-50 text-green-500'}`}>
        {type === 'error' ? <AlertTriangle size={20} /> : <Zap size={20} />}
     </div>
     <div className="space-y-2">
        <h4 className="font-bold text-[#041627]">{title}</h4>
        <p className="text-xs text-slate-500 leading-relaxed">{desc}</p>
        <button
          onClick={onAction}
          className={`text-xs font-bold px-4 py-2 rounded-lg ${type === 'error' ? 'bg-red-500 text-white hover:bg-red-600' : 'bg-green-500 text-white hover:bg-green-600'} transition-colors`}
        >
          {type === 'error' ? 'Fix Now' : 'Execute Opportunity'}
        </button>
     </div>
  </div>
);

export default AlertCard;